import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreateModelo145 from 'services/record/Modelo145/useCreateModelo145';
import useUpdateModelo145ByID from 'services/record/Modelo145/useUpdateModelo145';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormInputYear from 'components/blocks/ManagementNewForms/Inputs/FormInputYear';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormInputCheckBoxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';

const Modelo145 = ({ info, dataUser, onSuccess: _onSuccess }: { info: boolean; dataUser: any; onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, clearErrors, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createModelo145, dataCreateModelo145, errorCreateModelo145, loadingCreateModelo145, successCreateModelo145 } = useCreateModelo145();
    const { dataUpdateModelo145ById, errorUpdateModelo145ById, loadingUpdateModelo145ById, successUpdateModelo145ById, updateModelo145ById } = useUpdateModelo145ByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);
    void _onSuccess;

    const getValue = (...values: any[]) => values.find(value => value !== undefined && value !== null);
    const getArrayValue = (...values: any[]) => {
        const arrayValue = values.find(Array.isArray);
        return Array.isArray(arrayValue) ? arrayValue : [];
    };
    const normalizeSiNo = (value: any) => {
        if (value === true || value === 'true' || value === 1 || value === '1') return true;
        if (value === false || value === 'false' || value === 0 || value === '0') return false;
        return '';
    };
    const toBooleanOrFalse = (value: any) => {
        return value === true || value === 'true' || value === 1 || value === '1';
    };
    const toNumberOr = (value: any, fallback = null) => {
        if (value === null || value === undefined || value === '') return fallback;
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue : fallback;
    };
    const toNullableYear = (value: any) => {
        if (value === null || value === undefined || value === '') return null;
        const numericValue = Number(value);
        if (!Number.isFinite(numericValue) || numericValue <= 0) return null;
        return numericValue;
    };
    const toFloatOr = (value: any, fallback = 0) => {
        if (value === null || value === undefined || value === '') return fallback;
        if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
        const numericValue = Number(String(value).replace(',', '.'));
        return Number.isFinite(numericValue) ? numericValue : fallback;
    };
    const toIsoStringOrNull = (value: any) => {
        if (!value) return null;
        const dateValue = value instanceof Date ? value : new Date(value);
        return Number.isNaN(dateValue.getTime()) ? null : dateValue.toISOString();
    };
    const discapacidadToNumber = (value: any) => {
        if (value === null || value === undefined || value === '') return 0;
        if (typeof value === 'number' && Number.isFinite(value)) return value;

        const textValue = String(value).trim();
        if (/^\d+$/.test(textValue)) return Number(textValue);

        if (textValue === 'Sin Discapacidad') return 0;
        if (textValue === 'Superior o igual al 33% e Inferior al 65%') return 1;
        if (textValue === 'Superior o igual al 65%') return 2;

        const normalized = textValue.toLowerCase();
        if (normalized.includes('33') && normalized.includes('65')) return 1;
        if (normalized.includes('65')) return 2;

        return 0;
    };
    const discapacidadToLabel = (value: any) => {
        const code = discapacidadToNumber(value);
        if (code === 0) return 'Sin Discapacidad';
        if (code === 1) return 'Superior o igual al 33% e Inferior al 65%';
        if (code === 2) return 'Superior o igual al 65%';
        return '';
    };



    const adaptApiResponseToDefaultValues = (data: any) => {
        if (!data) return;

        const nombreCompleto = [data?.Nombre, data?.Apellido1, data?.Apellido2]
            .filter(Boolean)
            .join(" ")
            .trim();

        const anioNacimientoNumber = Number(data?.AnioNacimiento);
        const situacionFamiliar = data?.SituacionFamiliar;
        const discapacidad = data?.Discapacidad;
        const ayudaTercerasPersonas = data?.AyudaTercerasPersonas;
        const rendimientos = data?.Rendimientos;
        const movilidadGeograficaRaw = data?.MovilidadGeografica;
        const movilidadGeograficaDate = movilidadGeograficaRaw ? new Date(movilidadGeograficaRaw) : null;
        const pensionFavorDelConyuge = getValue(
            data?.PensionFavorDelConyuge,
            data?.pensionFavorDelConyuge,
            data?.PensionAdquisicion?.PensionFavorDelConyuge,
            data?.PensionAdquisicion?.pensionFavorDelConyuge,
            data?.pensionAdquisicion?.PensionFavorDelConyuge,
            data?.pensionAdquisicion?.pensionFavorDelConyuge,
            ''
        );
        const anualidadesAlimentosHijos = getValue(
            data?.AnualidadesAlimentosHijos,
            data?.anualidadesAlimentosHijos,
            data?.PensionAdquisicion?.AnualidadesAlimentosHijos,
            data?.PensionAdquisicion?.anualidadesAlimentosHijos,
            data?.pensionAdquisicion?.AnualidadesAlimentosHijos,
            data?.pensionAdquisicion?.anualidadesAlimentosHijos,
            ''
        );
        const adquisicionVivienda = getValue(
            data?.AdquisicionVivienda,
            data?.adquisicionVivienda,
            data?.PensionAdquisicion?.AdquisicionVivienda,
            data?.PensionAdquisicion?.adquisicionVivienda,
            data?.pensionAdquisicion?.AdquisicionVivienda,
            data?.pensionAdquisicion?.adquisicionVivienda,
            false
        );
        const hijosACargoSource = getArrayValue(
            data?.HijosACargo,
            data?.hijosACargo,
            data?.Hijos,
            data?.hijos,
        );
        const hijosACargo = hijosACargoSource.map((hijo: any) => ({
            AnioNacimiento: toNullableYear(getValue(hijo?.AnioNacimiento, hijo?.anioNacimiento)),
            AnioAcogimiento: toNullableYear(getValue(hijo?.AnioAcogimiento, hijo?.anioAcogimiento)),
            Discapacidad: discapacidadToLabel(getValue(hijo?.Discapacidad, hijo?.discapacidad)),
            AyudaTercerasPersonas: normalizeSiNo(getValue(hijo?.AyudaTercerasPersonas, hijo?.AyudaTerceraPersona, hijo?.ayudaTercerasPersonas, hijo?.ayudaTerceraPersona)),
            ComputoEntero: normalizeSiNo(getValue(hijo?.ComputoEntero, hijo?.computoEntero)),
        }));

        const ascendientesACargoSource = getArrayValue(
            data?.AscendientesACargo,
            data?.ascendientesACargo,
            data?.Ascendientes,
            data?.ascendientes,
        );
        const ascendientesACargo = ascendientesACargoSource.map((ascendiente: any) => ({
            AnioNacimiento: toNullableYear(getValue(ascendiente?.AnioNacimiento, ascendiente?.anioNacimiento)),
            Discapacidad: discapacidadToLabel(getValue(ascendiente?.Discapacidad, ascendiente?.discapacidad)),
            AyudaTercerasPersonas: normalizeSiNo(getValue(ascendiente?.AyudaTercerasPersonas, ascendiente?.AyudaTerceraPersona, ascendiente?.ayudaTercerasPersonas, ascendiente?.ayudaTerceraPersona)),
            ComputoEntero: normalizeSiNo(getValue(ascendiente?.ComputoEntero, ascendiente?.ConvivenciaOtrosDescendientes, ascendiente?.computoEntero, ascendiente?.convivenciaOtrosDescendientes)),
        }));

        reset({
            DatosPersonales: {
                SolicitanteNombreApellidos: nombreCompleto || "",
                SolicitanteIPF: data?.IPF || "",
                SolicitanteIPFTipo: (data?.IPFTipo ?? 1).toString(),
                SolicitanteAnioNacimiento:
                    Number.isFinite(anioNacimientoNumber) && anioNacimientoNumber > 0
                        ? anioNacimientoNumber
                        : null,
                SituacionFamiliar:
                    situacionFamiliar !== undefined && situacionFamiliar !== null
                        ? situacionFamiliar.toString()
                        : "",
                Discapacidad:
                    discapacidad !== undefined && discapacidad !== null
                        ? discapacidad.toString()
                        : "",
                AyudaTercerasPersonas: Boolean(ayudaTercerasPersonas),
                Rendimientos: Boolean(rendimientos),
                SolicitanteMovilidadGeografica:
                    movilidadGeograficaDate && !isNaN(movilidadGeograficaDate.getTime())
                        ? movilidadGeograficaDate
                        : null,
                ConyugeIPF: data?.ConyugeIPF || "",
                ConyugeIPFTipo: (data?.ConyugeIPFTipo ?? 1).toString()
            },
            PensionAdquisicion: {
                PensionFavorDelConyuge: pensionFavorDelConyuge,
                AnualidadesAlimentosHijos: anualidadesAlimentosHijos,
            },
            AdquisicionVivienda: {
                PagoAdquisicionViviendaHabitual: toBooleanOrFalse(adquisicionVivienda),
            },
            HijosACargo: fillArray(hijosACargo, 0, {
                AnioNacimiento: null,
                AnioAcogimiento: null,
                Discapacidad: null,
                AyudaTercerasPersonas: '',
                ComputoEntero: '',
            }),
            AscendientesACargo: fillArray(ascendientesACargo, 0, {
                AnioNacimiento: null,
                Discapacidad: null,
                AyudaTercerasPersonas: '',
                ComputoEntero: '',
            }),
        });

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);

    const hasYearValue = (value: any) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) && numericValue > 0;
    };

    const hasDiscapacidadValue = (value: any) => {
        return typeof value === 'string' ? value.trim() !== '' : value !== null && value !== undefined;
    };

    const hasYesNoAnswer = (value: any) => {
        return value === true || value === false;
    };

    const isEmptyRowHijo = (row: any) => {
        const hasNacimiento = hasYearValue(row?.AnioNacimiento);
        const hasAcogimiento = hasYearValue(row?.AnioAcogimiento);
        const hasDiscapacidad = hasDiscapacidadValue(row?.Discapacidad);
        const hasAyuda = hasYesNoAnswer(row?.AyudaTercerasPersonas);
        const hasComputo = hasYesNoAnswer(row?.ComputoEntero);

        return !hasNacimiento && !hasAcogimiento && !hasDiscapacidad && !hasAyuda && !hasComputo;
    };

    const isEmptyRowAscendiente = (row: any) => {
        const hasNacimiento = hasYearValue(row?.AnioNacimiento);
        const hasDiscapacidad = hasDiscapacidadValue(row?.Discapacidad);
        const hasAyuda = hasYesNoAnswer(row?.AyudaTercerasPersonas);
        const hasComputo = hasYesNoAnswer(row?.ComputoEntero);

        return !hasNacimiento && !hasDiscapacidad && !hasAyuda && !hasComputo;
    };

    const validateHijosACargo = (rows: any[] = []) => {
        const safeRows = Array.isArray(rows) ? rows : [];

        if (safeRows.length === 0) {
            return true;
        }

        for (let index = 0; index < safeRows.length; index++) {
            const row = safeRows[index] || {};
            const hasNacimiento = hasYearValue(row?.AnioNacimiento);
            const hasAcogimiento = hasYearValue(row?.AnioAcogimiento);
            const hasDiscapacidad = hasDiscapacidadValue(row?.Discapacidad);
            const hasAyuda = hasYesNoAnswer(row?.AyudaTercerasPersonas);
            const hasComputo = hasYesNoAnswer(row?.ComputoEntero);

            if (!hasNacimiento && !hasAcogimiento) {
                return `En Hijos a Cargo, la fila ${index + 1} debe tener Año de Nacimiento o Año de Acogimiento/Adopcion.`;
            }

            if (!hasDiscapacidad) {
                return `En Hijos a Cargo, la fila ${index + 1} debe completar Discapacidad.`;
            }

            if (!hasAyuda) {
                return `En Hijos a Cargo, la fila ${index + 1} debe completar Ayuda a Terceras Personas.`;
            }

            if (!hasComputo) {
                return `En Hijos a Cargo, la fila ${index + 1} debe completar Cómputo por Entero.`;
            }
        }

        return true;
    };

    const validateAscendientesACargo = (rows: any[] = []) => {
        const safeRows = Array.isArray(rows) ? rows : [];

        if (safeRows.length === 0) {
            return true;
        }

        for (let index = 0; index < safeRows.length; index++) {
            const row = safeRows[index] || {};
            const hasNacimiento = hasYearValue(row?.AnioNacimiento);
            const hasDiscapacidad = hasDiscapacidadValue(row?.Discapacidad);
            const hasAyuda = hasYesNoAnswer(row?.AyudaTercerasPersonas);
            const hasComputo = hasYesNoAnswer(row?.ComputoEntero);

            const missingFields: string[] = [];
            if (!hasNacimiento) missingFields.push('Año de Nacimiento');
            if (!hasDiscapacidad) missingFields.push('Discapacidad');
            if (!hasAyuda) missingFields.push('Ayuda a Terceras Personas');
            if (!hasComputo) missingFields.push('Cómputo por Entero');

            if (missingFields.length > 0) {
                return `En Ascendientes a Cargo, la fila ${index + 1} debe completar: ${missingFields.join(', ')}.`;
            }
        }

        return true;
    };

    const setAscendientesFieldErrors = (rows: any[] = []) => {
        const safeRows = Array.isArray(rows) ? rows : [];

        for (let index = 0; index < safeRows.length; index++) {
            const row = safeRows[index] || {};

            const hasNacimiento = hasYearValue(row?.AnioNacimiento);
            const hasDiscapacidad = hasDiscapacidadValue(row?.Discapacidad);
            const hasAyuda = hasYesNoAnswer(row?.AyudaTercerasPersonas);
            const hasComputo = hasYesNoAnswer(row?.ComputoEntero);

            if (!hasNacimiento) {
                setError(`AscendientesACargo.${index}.AnioNacimiento` as any, {
                    type: 'manual',
                    message: 'Campo obligatorio',
                });
            }

            if (!hasDiscapacidad) {
                setError(`AscendientesACargo.${index}.Discapacidad` as any, {
                    type: 'manual',
                    message: 'Campo obligatorio',
                });
            }

            if (!hasAyuda) {
                setError(`AscendientesACargo.${index}.AyudaTercerasPersonas` as any, {
                    type: 'manual',
                    message: 'Debe responder Sí o No',
                });
            }

            if (!hasComputo) {
                setError(`AscendientesACargo.${index}.ComputoEntero` as any, {
                    type: 'manual',
                    message: 'Debe responder Sí o No',
                });
            }
        }
    };

    const validateTablasModelo145 = (data: any) => {
        clearErrors(['HijosACargo', 'AscendientesACargo']);
        let isValid = true;

        const hijosValidation = validateHijosACargo(data?.HijosACargo ?? []);
        if (hijosValidation !== true) {
            setError('HijosACargo.root' as any, {
                type: 'manual',
                message: hijosValidation,
            });
            isValid = false;
        }

        const ascendientesValidation = validateAscendientesACargo(data?.AscendientesACargo ?? []);
        if (ascendientesValidation !== true) {
            setError('AscendientesACargo.root' as any, {
                type: 'manual',
                message: ascendientesValidation,
            });
            setAscendientesFieldErrors(data?.AscendientesACargo ?? []);
            isValid = false;
        }

        return isValid;
    };




    const onSubmit = async (data: any) => {
        console.log(data);

        if (!validateTablasModelo145(data)) {
            return;
        }

        setLoader(true);

        const userId = String(dataUser?.UsuarioId ?? '');
        const formId = String(dataUser?.Id ?? '');
        const situacionFamiliar = toNumberOr(data?.DatosPersonales?.SituacionFamiliar, 0);

        const nombreCompleto = (data?.DatosPersonales?.SolicitanteNombreApellidos || '').trim();
        let nombre = getValue(dataUser?.Nombre, datosAPI?.Nombre, '');
        let apellido1 = getValue(dataUser?.Apellido1, datosAPI?.Apellido1, '');
        let apellido2 = getValue(dataUser?.Apellido2, datosAPI?.Apellido2, '');

        if ((!nombre || !apellido1) && nombreCompleto) {
            const parts = nombreCompleto.split(/\s+/).filter(Boolean);
            nombre = nombre || parts[0] || '';
            apellido1 = apellido1 || parts[1] || '';
            apellido2 = apellido2 || parts.slice(2).join(' ') || '';
        }

        const hijosOrigen = getArrayValue(
            dataUser?.HijosACargo,
            dataUser?.hijosACargo,
            dataUser?.Hijos,
            dataUser?.hijos,
        );
        const ascendientesOrigen = getArrayValue(
            dataUser?.AscendientesACargo,
            dataUser?.ascendientesACargo,
            dataUser?.Ascendientes,
            dataUser?.ascendientes,
        );

        const datosEnvio = {
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: dataUser?.PrestacionId || null,
            Acepto: data?.Acepto ?? false,

            nombre: nombre || '',
            apellido1: apellido1 || '',
            apellido2: apellido2 || '',
            ipf: data?.DatosPersonales?.SolicitanteIPF || '',
            ipfTipo: toNumberOr(data?.DatosPersonales?.SolicitanteIPFTipo, 1),
            anioNacimiento: toNumberOr(data?.DatosPersonales?.SolicitanteAnioNacimiento, 0),
            situacionFamiliar,
            conyugeIPF: situacionFamiliar === 1 ? (data?.DatosPersonales?.ConyugeIPF || '') : '',
            conyugeIPFTipo: situacionFamiliar === 1
                ? toNumberOr(data?.DatosPersonales?.ConyugeIPFTipo, 1)
                : 1,
            discapacidad: toNumberOr(data?.DatosPersonales?.Discapacidad, 0),
            ayudaTercerasPersonas: data?.DatosPersonales?.AyudaTercerasPersonas === true,
            movilidadGeografica: toIsoStringOrNull(data?.DatosPersonales?.SolicitanteMovilidadGeografica),
            rendimientos: data?.DatosPersonales?.Rendimientos === true,
            hijosACargo: (data?.HijosACargo ?? []).map((hijo: any, index: number) => ({
                externalId: getValue(hijo?.ExternalId, hijo?.externalId, hijosOrigen?.[index]?.ExternalId, hijosOrigen?.[index]?.externalId, 0) ?? 0,
                id: getValue(hijo?.Id, hijo?.id, hijosOrigen?.[index]?.Id, hijosOrigen?.[index]?.id, null),
                anioNacimiento: toNullableYear(getValue(hijo?.AnioNacimiento, hijo?.anioNacimiento)),
                anioAcogimiento: toNullableYear(getValue(hijo?.AnioAcogimiento, hijo?.anioAcogimiento)),
                discapacidad: discapacidadToNumber(getValue(hijo?.Discapacidad, hijo?.discapacidad)),
                ayudaTerceraPersona: toBooleanOrFalse(getValue(hijo?.AyudaTercerasPersonas, hijo?.AyudaTerceraPersona, hijo?.ayudaTercerasPersonas, hijo?.ayudaTerceraPersona)),
                computoEntero: toBooleanOrFalse(getValue(hijo?.ComputoEntero, hijo?.computoEntero)),
            })),
            ascendientes: (data?.AscendientesACargo ?? []).map((ascendiente: any, index: number) => ({
                externalId: getValue(ascendiente?.ExternalId, ascendiente?.externalId, ascendientesOrigen?.[index]?.ExternalId, ascendientesOrigen?.[index]?.externalId, 0) ?? 0,
                id: getValue(ascendiente?.Id, ascendiente?.id, ascendientesOrigen?.[index]?.Id, ascendientesOrigen?.[index]?.id, null),
                anioNacimiento: toNullableYear(getValue(ascendiente?.AnioNacimiento, ascendiente?.anioNacimiento)),
                discapacidad: discapacidadToNumber(getValue(ascendiente?.Discapacidad, ascendiente?.discapacidad)),
                ayudaTerceraPersona: toBooleanOrFalse(getValue(ascendiente?.AyudaTercerasPersonas, ascendiente?.AyudaTerceraPersona, ascendiente?.ayudaTercerasPersonas, ascendiente?.ayudaTerceraPersona)),
                convivenciaOtrosDescendientes: toBooleanOrFalse(getValue(ascendiente?.ComputoEntero, ascendiente?.computoEntero)),
            })),
            pensionFavorDelConyuge: toFloatOr(getValue(data?.PensionAdquisicion?.PensionFavorDelConyuge, data?.PensionFavorDelConyuge), 0),
            anualidadesAlimentosHijos: toFloatOr(getValue(data?.PensionAdquisicion?.AnualidadesAlimentosHijos, data?.AnualidadesAlimentosHijos), 0),
            adquisicionVivienda: toBooleanOrFalse(getValue(data?.AdquisicionVivienda?.PagoAdquisicionViviendaHabitual, data?.AdquisicionVivienda)),
        };

        if (info) {
            await createModelo145(userId, datosEnvio, _onSuccess);
            setBloquearEnvio(true);
        } else {
            await updateModelo145ById(userId, formId, datosEnvio, _onSuccess);
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={getValue(datosAPI?.EstadoFormulario, datosAPI?.estadoFormulario, dataUser?.EstadoFormulario, dataUser?.estadoFormulario)}
                    estadoFormularioDescripcion={getValue(datosAPI?.EstadoFormularioDescripcion, datosAPI?.estadoFormularioDescripcion, dataUser?.EstadoFormularioDescripcion, dataUser?.estadoFormularioDescripcion)}
                    fechaActualizacionEstado={getValue(datosAPI?.FechaActualizacionEstado, datosAPI?.fechaActualizacionEstado, dataUser?.FechaActualizacionEstado, dataUser?.fechaActualizacionEstado)}
                />

                <Loader activeLoader={loader || loadingCreateModelo145 || loadingUpdateModelo145ById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS PERSONALES ////////////// */}



                <AccordionForm title={'Datos Personales'} expandedInit={false} nombreError='DatosPersonales' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="Datos del Solicitante" disabled={false}>

                                <FormInputText
                                    name='DatosPersonales.SolicitanteNombreApellidos'
                                    id='DatosPersonales.SolicitanteNombreApellidos'
                                    label='Nombre y apellidos del solicitante'
                                    md={12}
                                    xl={12}
                                    disabled={true}
                                />
                                <FormInputIPF
                                    id={`DatosPersonales.SolicitanteIPF`}
                                    name={`DatosPersonales.SolicitanteIPF`}
                                    label="IPF (Identificación Personal Fisica)"
                                    xl={6}
                                    md={6}
                                    placeholder={''}
                                    disabled={true}
                                />
                                <FormInputYear
                                    id="DatosPersonales.SolicitanteAnioNacimiento"
                                    name="DatosPersonales.SolicitanteAnioNacimiento"
                                    label="Año de Nacimiento"
                                    placeholder=""
                                    md={6}
                                    xl={6}
                                    col={12}
                                    maxDate={new Date()}
                                    disableDate={
                                        true
                                    }
                                    req={'El año de nacimiento es obligatorio'}
                                />

                                <FormInputRadioGroup
                                    name='DatosPersonales.SituacionFamiliar'
                                    title='Situacion Familiar'
                                    required='Especifique su situación familiar'
                                    labels={[
                                        'Soltero/a, viudo/a, divorciado/a o separado/a',
                                        'Casado/a y no separado/a',
                                        'Situacion Familiar distinta'
                                    ]}
                                    modal={[
                                        'Soltero/a, viudo/a, divorciado/a o separado/a legalmente con hijos solteros menores de 18 años o incapacitados judicialmente que conviven exclusivamente con Vd., sin convivir también con el otro progenitor, siempre que proceda consignar al menos un hijo o descendiente en el siguiente apartado de este formulario',
                                        'Casado/a y no separado/a legalmente cuyo cónyuge no obtiene rentas superiores a 1.500 euros anuales, excluidas las exentas',
                                        'Situación familiar distinta de las dos anteriores (solteros sin hijos, casados cuyo cónyuge obtiene rentas superiores a 1.500 euros anuales, ..., etc.) (Marque también esta casilla si no desea manifestar su situación familiar)'
                                    ]}
                                />

                                <AccordionDisplay
                                    dataUser={dataUser}
                                    visibility={watch('DatosPersonales.SituacionFamiliar') === '1'}
                                    fields={['DatosPersonales.ConyugeIPF', 'DatosPersonales.ConyugeIPFTipo']}
                                >
                                    <FormInputIPF
                                        id='DatosPersonales.ConyugeIPF'
                                        name='DatosPersonales.ConyugeIPF'
                                        label='IPF del Conyuge'
                                        xl={12}
                                        md={12}
                                        placeholder=''
                                        disabled={false}
                                        req={watch('DatosPersonales.SituacionFamiliar') === '1' ? 'Es necesario introducir el IPF del Conyuge' : false}
                                    />
                                </AccordionDisplay>

                                <FormInputRadioGroup
                                    name='DatosPersonales.Discapacidad'
                                    title='Discapacidad'
                                    labels={[
                                        'Sin Discapacidad',
                                        'Superior o igual al 33% e Inferior al 65%',
                                        'Superior o igual al 65%'
                                    ]}
                                />
                                <div className='mb-3'>

                                </div>
                                <FormInputCheckBoxTable
                                    labels={['Además, tengo acreditada la necesidad de ayuda de terceras personas o movilidad reducida']}
                                    names={['DatosPersonales.AyudaTercerasPersonas']}
                                />

                                <FormInputFecha
                                    modal='Si anteriormente estaba Vd. en situación de desempleo e inscrito en la oficina de empleo y la aceptación del puesto de trabajo actual ha exigido el traslado de su residencia habitual a un nuevo municipio, indique la fecha de dicho traslado'
                                    name='DatosPersonales.SolicitanteMovilidadGeografica'
                                    id='DatosPersonales.SolicitanteMovilidadGeografica'
                                    label='Movilidad Geográfica'
                                    md={12}
                                    xl={12}
                                />

                                <FormInputCheckBoxTable
                                    title='Obtención de rendimientos con período de generación superior a 2 años durante los 5 períodos impositivos anteriores.'
                                    labels={['Marque si procede']}
                                    names={['DatosPersonales.Rendimientos']}
                                    modal={['Marque esta casilla si, en el plazo comprendido en los 5 períodos impositivos anteriores al ejercicio al que corresponde la presente comunicación, ha percibido rendimientos del trabajo con período de generación superior a 2 años, a los que, a efectos del cálculo del tipo de retención le haya sido aplicada la reducción por irregularidad contemplada en el artículo 18.2 de la Ley del Impuesto y, sin embargo, posteriormente usted no haya aplicado la citada reducción en su correspondiente autoliquidación del Impuesto sobre la Renta']}
                                />


                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Personas A Cargo'} expandedInit={false} nombreError='HijosACargo' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer
                                legend='Hijos y otros descendientes menores de 25 años, o mayores de dicha edad si son discapacitados, que conviven con el perceptor'
                                disabled={false}
                            >
                                <p className='input-block__label m-0'>Datos de los Hijos a Cargo</p>
                                <FormInputTable
                                    name='HijosACargo'
                                    heads={['Año de Nacimiento', 'Año de Acogimiento/Adopcion', 'Discapacidad', 'Ayuda Terceras Personas', 'Cómputo por Entero']}
                                    nameHeads={['AnioNacimiento', 'AnioAcogimiento', 'Discapacidad', 'AyudaTercerasPersonas', 'ComputoEntero']}
                                    arrayModal={['', '', '', 'Tengo acreditada la necesidad de ayuda de terceras personas o movilidad reducida', 'En caso de hijos que convivan únicamente con Vd., sin convivir también con el otro progenitor (padre o madre), o de nietos que convivan únicamente con Vd., sin convivir también con ningún otro de sus abuelos, indíquelo marcando la casilla.']}
                                    inputType={[9, 9, 6, 5, 5]}
                                    widthColumn={[1, 1, 1, 1, 1]}
                                    validateFunction={validateHijosACargo}

                                />

                            </FieldsetContainer>
                            <FieldsetContainer
                                legend='Ascendientes mayores de 65 años, o menores de dicha edad si son discapacitados, que conviven con el perceptor'
                                disabled={false}
                            >
                                <p className='input-block__label m-0 '>Ascendiente a cargo</p>
                                <FormInputTable
                                    name='AscendientesACargo'
                                    heads={['Año de Nacimiento', 'Discapacidad', 'Ayuda Terceras Personas', 'Convivencia con otros descendientes']}
                                    nameHeads={['AnioNacimiento', 'Discapacidad', 'AyudaTercerasPersonas', 'ComputoEntero']}
                                    arrayModal={['', '', 'Tengo acreditada la necesidad de ayuda de terceras personas o movilidad reducida', 'Si alguno de los ascendientes convive también, al menos durante la mitad del año, con otros descendientes del mismo grado que Vd., indique en esta casilla el número total de descendientes con los que convive, incluido Vd. (Si los ascendientes sólo conviven con Vd., no rellene esta casilla).']}
                                    inputType={[9, 6, 5, 5]}
                                    widthColumn={[1, 1, 1, 1]}
                                    validateFunction={validateAscendientesACargo}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Pensiones'} expandedInit={false} nombreError='Pensiones' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend='' disabled={false}>
                                <FormInputText
                                    id="PensionAdquisicion.PensionFavorDelConyuge"
                                    name="PensionAdquisicion.PensionFavorDelConyuge"
                                    label="Pensión compensatoria en favor del cónyuge."
                                    placeholder=""
                                    disabled={false}
                                    xl={6}
                                    md={6}
                                    pattern={/^\d+(?:[.,]\d+)?$/}
                                    patternMessage='Solo se permiten valores numericos y decimales'
                                    modal='Importe anual que está Vd. obligado a satisfacer por resolución judicial'
                                />
                                <FormInputText
                                    id="PensionAdquisicion.AnualidadesAlimentosHijos"
                                    name="PensionAdquisicion.AnualidadesAlimentosHijos"
                                    label="Anualidades por alimentos en favor de los hijos."
                                    placeholder=""
                                    xl={6}
                                    md={6}
                                    disabled={false}
                                    pattern={/^\d+(?:[.,]\d+)?$/}
                                    patternMessage='Solo se permiten valores numericos y decimales'
                                    modal='Importe anual que está Vd. obligado a satisfacer por resolución judicial'
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Adquisicion de Vivienda'} expandedInit={false} nombreError='AdquisicionVivienda' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend='' disabled={false}>
                                <p className='mb-2'>Importante: sólo podrán cumplimentar este apartado los contribuyentes que hayan adquirido su vivienda habitual, o hayan satisfecho cantidades por obras de rehabilitación de la misma, antes del 1 de enero de 2013 Si está Vd. efectuando pagos por préstamos destinados a la adquisición o rehabilitación de su vivienda habitual por los que vaya a tener derecho a deducción por inversión en vivienda habitual en el IRPF y la cuantía total de sus retribuciones íntegras en concepto de rendimientos del trabajo procedentes de todos sus pagadores es inferior a 33.007,20 euros anuales</p>
                                <FormInputCheckBoxTable
                                    title='Pago por la adquisición o rehabilitación de la vivienda habitual utilizando financiación ajena, con derecho a deducción en el IRPF'
                                    labels={['Marque si procede']}
                                    names={['AdquisicionVivienda.PagoAdquisicionViviendaHabitual']}
                                />
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>
















                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateModelo145}
                    successUpdate={successUpdateModelo145ById}
                    errorCreate={errorCreateModelo145}
                    errorUpdate={errorUpdateModelo145ById}
                    datosAPI={datosAPI}
                    info={info}
                    label='Manifiesto ser contribuyente del IRPF y declaro que son ciertos los datos arriba indicados, presentando ante la empresa o entidad pagadora la presente comunicación de mi situación personal y familiar, o de su variación, a los efectos previstos en el artículo 88 del Reglamento del IRPF'
                />


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default Modelo145
